import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Confetti from 'react-confetti';

const PageContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 40px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 215, 0, 0.2);
  backdrop-filter: blur(3px);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 42px;
  margin-bottom: 40px;
  text-align: center;
  color: var(--gold-color);
  text-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
`;

const ResultText = styled.div`
  font-size: 24px;
  margin: 20px 0;
  color: var(--gold-color);
  text-shadow: 0 1px 5px rgba(255, 215, 0, 0.3);
`;

const SalaryAmount = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: var(--gold-color);
  text-shadow: 0 2px 15px rgba(255, 215, 0, 0.6);
  display: block;
  margin: 15px 0;
`;

const TimeAmount = styled.span`
  font-size: 32px;
  font-weight: bold;
  color: var(--gold-color);
  text-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
  display: block;
  margin: 15px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  gap: 20px;
`;

const Button = styled.button`
  padding: 15px 30px;
  background: rgba(212, 175, 55, 0.8);
  border: none;
  color: #000;
  font-weight: bold;
  font-size: 18px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: var(--main-font);
  
  &:hover {
    background: rgba(255, 215, 0, 0.9);
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
`;

const ConfettiWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  pointer-events: none;
`;

const GoldCoinVideo = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 200;
  pointer-events: none;
  opacity: ${props => props.opacity};
  transition: opacity 1s ease-in-out;
  mix-blend-mode: screen;
`;

const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 2s ease;
  opacity: 0.7;
`;

const ResultPage = () => {
  const navigate = useNavigate();
  const [result, setResult] = useState({ duration: 0, earnedSalary: 0 });
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [showGoldCoin, setShowGoldCoin] = useState(false);
  const [goldCoinOpacity, setGoldCoinOpacity] = useState(0);
  
  // 播放金币视频的函数
  const playGoldCoinVideo = () => {
    console.log("结果页面：尝试播放金币视频");
    
    // 先显示视频容器
    setShowGoldCoin(true);
    setGoldCoinOpacity(0.3);
    
    // 给DOM时间渲染
    setTimeout(() => {
      const videoElement = document.querySelector('.gold-coin-video');
      console.log("结果页面：查找视频元素", videoElement);
      
      if (videoElement) {
        // 设置视频属性
        videoElement.muted = true;
        videoElement.currentTime = 0;
        videoElement.loop = false; // 确保视频不循环播放
        
        // 播放视频
        console.log("结果页面：开始播放金币视频");
        videoElement.play()
          .then(() => {
            console.log("结果页面：金币视频开始播放成功");
            // 淡入
            setGoldCoinOpacity(0.8); // 最大不透明度设为80%
            
            // 监听视频结束事件
            videoElement.onended = () => {
              console.log("结果页面：金币视频播放结束");
              handleGoldCoinEnd();
            };
            
            // 设置安全定时器，确保视频会在一定时间后消失
            // 视频时长约为4-5秒，设置6秒的定时器确保视频会结束
            setTimeout(() => {
              console.log("结果页面：金币视频播放超时，强制结束");
              handleGoldCoinEnd();
            }, 6000);
          })
          .catch(error => {
            console.error("结果页面：金币视频播放失败:", error);
          });
      } else {
        console.error("结果页面：找不到视频元素");
      }
    }, 500);
  };
  
  // 处理金币视频结束的函数
  const handleGoldCoinEnd = () => {
    // 淡出
    setGoldCoinOpacity(0);
    setTimeout(() => {
      setShowGoldCoin(false);
      console.log("结果页面：隐藏金币视频元素");
    }, 1000);
  };
  
  useEffect(() => {
    // 监听窗口大小变化
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    
    window.addEventListener('resize', handleResize);
    
    // 从 localStorage 获取结果
    const savedResult = JSON.parse(localStorage.getItem('workResult') || '{"duration":0,"earnedSalary":0}');
    setResult(savedResult);
    
    // 页面加载时播放金币视频，但需要延迟确保DOM已加载
    setTimeout(() => {
      console.log("结果页面：延迟后尝试播放金币视频");
      playGoldCoinVideo();
    }, 1000);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const handleRestart = () => {
    navigate('/');
  };
  
  const handleContinue = () => {
    navigate('/working');
  };
  
  // 格式化时间显示
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    let timeString = '';
    if (hours > 0) {
      timeString += `${hours}小时`;
    }
    if (minutes > 0 || hours > 0) {
      timeString += `${minutes}分钟`;
    }
    timeString += `${seconds}秒`;
    
    return timeString;
  };

  return (
    <>
      <ConfettiWrapper>
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          recycle={true}
          numberOfPieces={400}
          colors={['#FFD700', '#D4AF37', '#F5F5DC', '#FFFACD', '#FFDF00']}
          gravity={0.15}
        />
      </ConfettiWrapper>
      
      {showGoldCoin && (
        <GoldCoinVideo opacity={goldCoinOpacity}>
          <VideoElement 
            className="gold-coin-video"
            muted
            playsInline
            preload="auto"
            src="/mp4/bg-gold.mp4"
            type="video/mp4"
            onError={(e) => console.error("结果页面：视频加载错误:", e)}
            onLoadStart={() => console.log("结果页面：视频开始加载")}
            onLoadedData={() => console.log("结果页面：视频数据加载完成")}
          />
        </GoldCoinVideo>
      )}
      
      <PageContainer>
        <Title>恭喜您完成工作！</Title>
        
        <ResultText>
          今日上班时间:
          <TimeAmount>{formatTime(result.duration)}</TimeAmount>
        </ResultText>
        
        <ResultText>
          今日已赚:
          <SalaryAmount>¥{result.earnedSalary.toFixed(2)}</SalaryAmount>
        </ResultText>
        
        <ButtonContainer>
          <Button onClick={handleRestart}>重新设置</Button>
          <Button onClick={handleContinue}>继续上班</Button>
        </ButtonContainer>
      </PageContainer>
    </>
  );
};

export default ResultPage; 